import {Sidebar} from "primereact/sidebar";
import {InputText} from "primereact/inputtext";
import {Calendar} from "primereact/calendar";
import {InputNumber} from "primereact/inputnumber";
import {Button} from "primereact/button";
import {Slot} from "../../data/Slot";
import {useEffect, useState} from "react";
import {Checkbox} from "primereact/checkbox";

interface SlotEditSidebarProps {
    visible: boolean;
    onHide: () => void;
    slot: Slot;
    onSave: (updatedSlot: Slot) => void;
}

function SlotEditSidebar({
                             visible,
                             onHide,
                             slot,
                             onSave,
                         }: SlotEditSidebarProps) {
    const [editedSlot, setEditedSlot] = useState<Slot>({...slot});

    useEffect(() => {
        setEditedSlot({...slot});
    }, [slot])

    const handleSave = () => {
        onSave(editedSlot!);
    };

    return (
        <Sidebar
            visible={visible}
            onHide={onHide}
            header="Termin bearbeiten"
            position="right"
            style={{width: "30rem"}}
        >
            <div className="p-fluid">
                <div className="field">
                    <label htmlFor="startDateTime">Startzeit</label>
                    <Calendar
                        id="startDateTime"
                        value={editedSlot.startDateTime}
                        onChange={(e) =>
                            setEditedSlot({
                                ...editedSlot,
                                startDateTime: e.value as Date,
                            })
                        }
                        showTime
                        hourFormat="24"
                    />
                </div>
                <div className="field">
                    <label htmlFor="endDateTime">Endzeit</label>
                    <Calendar
                        id="endDateTime"
                        value={editedSlot.endDateTime}
                        onChange={(e) =>
                            setEditedSlot({
                                ...editedSlot,
                                endDateTime: e.value as Date,
                            })
                        }
                        showTime
                        hourFormat="24"
                    />
                </div>
                <div className="field">
                    <label htmlFor="capacity">Plätze</label>
                    <InputNumber
                        id="capacity"
                        value={editedSlot.capacity}
                        showButtons
                        onChange={(e) =>
                            setEditedSlot({
                                ...editedSlot,
                                capacity: e.value as number,
                            })
                        }
                    />
                </div>
                <div className="field">
                    <label htmlFor="comment">Kommentar</label>
                    <InputText
                        id="comment"
                        value={editedSlot.comment}
                        onChange={(e) =>
                            setEditedSlot({
                                ...editedSlot,
                                comment: e.target.value,
                            })
                        }
                    />
                </div>
                <span className="p-float-label">
                    <Checkbox value={"test"} checked={editedSlot.disabled}
                              onChange={(e) => setEditedSlot({...slot, disabled: e.target.checked!})}/>
                    <label className="ml-3">Gesperrt</label>
                </span>
                <Button
                    label="Speichern"
                    icon="pi pi-check"
                    onClick={handleSave}
                    className="mt-3"
                />
            </div>
        </Sidebar>
    );
}

export default SlotEditSidebar;
